import { ImagesFlowDataType } from '@/common/components/camera/types/cameraStore.type';
import { SliderEnum } from '@/common/components/camera/types/components.type';
import { ImageFlowStoreType } from '@/modules/adjusterReportModules/IncidentParticipants/store/imageFlow/imageFlowStore.type';
import { create } from 'zustand';

const initialImages: ImageFlowStoreType['images'] = {
  damagedImages: [],
  vehicleImages: [],
  extraImages: [],
};
export const useImageFlowStore = create<ImageFlowStoreType>((set) => ({
  video: null,
  images: initialImages,
  isEditAble: true,

  setVideo: (video) => {
    set({ video });
  },
  setImages: ({ images, type }) => {
    switch (type) {
      case SliderEnum.VEHICLE:
        set((state) => ({
          images: {
            ...state.images,
            vehicleImages: [...state.images.vehicleImages, ...images],
          },
        }));
        break;

      case SliderEnum.DAMAGED_PARTS:
        set((state) => ({
          images: {
            ...state.images,
            damagedImages: [...state.images.damagedImages, ...images],
          },
        }));
        break;
      case SliderEnum.EXTRA_IMAGES:
        set((state) => ({
          images: {
            ...state.images,
            extraImages: [...state.images.extraImages, ...images],
          },
        }));
        break;

      default:
        set((state) => ({
          ...state,
        }));
        break;
    }
  },
  addImages: (images: ImagesFlowDataType) => {
    switch (images.type) {
      case SliderEnum.VEHICLE:
        set((state) => ({
          images: {
            ...state.images,
            vehicleImages: [...state.images.vehicleImages, images],
          },
        }));
        break;

      case SliderEnum.DAMAGED_PARTS:
        set((state) => ({
          images: {
            ...state.images,
            damagedImages: [...state.images.damagedImages, images],
          },
        }));
        break;

      default:
        set((state) => ({
          ...state,
        }));
        break;
    }
  },
  deleteDamagePart: (id: number) => {
    set((state) => ({
      images: {
        ...state.images,
        damagedImages: state.images.damagedImages.filter(
          (item) => item.id !== id,
        ),
      },
    }));
  },
  clearImages: () => {
    set({ images: initialImages });
  },
  clearVideo: () => {
    set({ video: null });
  },
  resetCameraStore: () => {
    set({ video: null, images: initialImages });
  },
}));
